import React from 'react';
import { func } from 'prop-types';

import styles from './Arrows.scss';

function PrevArrow({ onClick }) {
  return (
    <div className={styles.prev} onClick={onClick}>
      <div className={styles.arrow} />
    </div>
  );
}

PrevArrow.defaultProps = {
  onClick: () => {},
};

PrevArrow.propTypes = {
  onClick: func,
};

export default PrevArrow;



// WEBPACK FOOTER //
// ./app/components/ChannelBar/components/Arrows/PrevArrow.jsx